import {FAILURE, PENDING, SUCCESS} from '../../constants'

export const UU_FAILURE = `UPDATE_USERS_${FAILURE}`
export const UU_PENDING = `UPDATE_USERS_${PENDING}`
export const UU_SUCCESS = `UPDATE_USERS_${SUCCESS}`
